document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    console.log('hit')
    console.log(hit)
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
        <a
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          href="${algoliaShopify.helpers.instantsearchLink(hit)}"
          title="${algoliaShopify.helpers.fullTitle(
            hit.title,
            hit._distinct,
            hit.variant_title
          )}"
        >
          <img
            class="ais-hit--picture"
            src="${algoliaShopify.helpers.largeImage(hit)}"
            alt="${hit.title} - ${hit.variant_title}"
          />
        </a>

        <div class="ais-hit--details">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>

          <p class="ais-hit--price">
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    ).replace('.00','')}</span
                  ></span
                >
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct).replace('.00','')}</b>
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });
});





document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          FILTERS
        </div>

        <div class="ais-custom-wrap">
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header flex aic jcb">
            <div class="flex aic">
              <button class="ais-filters-btn">FILTERS</button>
              <div class="ais-stats-container"></div>
            </div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        </div><!-- end ais-custom-wrap -->
        <div class="ais-pagination-container"></div>
        
      </div>
    `;
  });
});


document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeRecommendHitTemplate', function(_defaultTemplate, html, item) {
    //console.log('item--------------')
    //console.log(item)

    async function getData (item){
      const res = await getProductMetafields(item.id);
      //console.log('res')
      //console.log(res);
      //console.log(flatlayImage(res.data))
      const flatlayImgSrc = flatlayImage(res.data);
      document.getElementById(`Card--${item.objectID}-${item.__queryID}`).getElementsByClassName('ais-hit--picture')[0].src = flatlayImgSrc;

      buildQuickShop( res, item);
    }
    getData(item);
    
    return html`
    <div
      id="${item.objectID}"
      class="card-wrapper product-card-wrapper underline-links-hover"
    >
      <div
        class="card card--standard card--media"
        style="--ratio-percent: 100%;"
      >
        <div
          id="Card--${item.objectID}-${item.__queryID}"
          class="card__inner gradient ratio"
          style="--ratio-percent: 100%"
        >
          <div class="card__content">
            <a
              id="StandardCardNoMediaLink--${item.objectID}"
              class="full-unstyled-link"
              aria-labelledby="StandardCardNoMediaLink--${item.objectID} NoMediaStandardBadge--${item.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(item)}"
            >
              <img
                class="ais-hit--picture"
                src="https://cdn.shopify.com/s/files/1/0056/5306/9927/files/blank.gif?v=1741895917"
                alt="${item.title} - ${item.variant_title}"
              />
            </a>
            <div class="alg-quickshop"></div>
          </div>
        </div>
      </div>
    </div>
    `;
    function getProductMetafields(pid){
      return new Promise((resolve) => {
        const query =  `query getProductById($id: ID!) {
          product(id: $id) {
            title,
            handle,
            id,
            images(first:20){
              edges {
                node {
                  src,
                  altText
                }
              }
            },
            variants(first:20){
              edges{
                node {
                  id,
                  price {
                    amount,
                    currencyCode
                  },
                  compareAtPrice {
                    amount,
                    currencyCode
                  },
                  availableForSale,
                  quantityAvailable,
                  selectedOptions {
                    name,
                    value,
                  }
                }
              }
            }
          }
        }`

        fetch('https://alcltd.com/api/graphql', {
          method: "POST",
          headers: {
            "X-Shopify-Storefront-Access-Token":"0a97b8d04e9fa46e6dd586216f958e46",
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ 
            query: query,
            variables: {
              id: `gid://shopify/Product/${pid}`,
            }
          })
        }).then(res => {
          return res.json();  
        }).then(data => {
          resolve(data)
        }).catch(err => {
          console.log(err)
        })
      });
    }

    function flatlayImage(data){
      let imgObj = data.product.images.edges.find(img => img.node.altText?.replaceAll(' ','').toLowerCase().includes('flatlay'));
      if(imgObj) {
        return imgObj.node.src + '&width=350';
      } else {
        return data.product.images.edges[data.product.images.edges.length - 1].node.src + '&width=350';
      } 
    }
  })
})
//src="${algoliaShopify.helpers.largeImage(item)}"


function buildQuickShop(res, item){
  let buttonHTML = ``;
  let optionsHTML = ``;
  let title = res.data.product.title;
  let pid = res.data.product.id;
  //let price = res.data.product.priceRangV2.minVariantPrice.amount.split('.')[0];
  let price = res?.data?.product?.variants.edges[0].node.price.amount.split('.')[0];
  let compareAtPrice = 0;
  if(res?.data?.product?.variants.edges[0].node.compareAtPrice){
    compareAtPrice = res?.data?.product?.variants.edges[0].node.compareAtPrice.amount.split('.')[0];
  }
  
  //let currencyCode = res?.data?.product?.variants.edges[0].node.price.currencyCode;

  let firstAvailableVariantIndex = res?.data?.product?.variants.edges.findIndex( edge => edge.node.quantityAvailable > 0);

  let priceHTML = `<span class="regular-price no-sale" itemprop="price" content="${price}">${currencySymbol}${price}</span>`;
  if(compareAtPrice > price){
    priceHTML = 
    `<s class="compare-price">${currencySymbol}${compareAtPrice}</s>        
    <span class="regular-price" itemprop="price" content="${price}">
      ${currencySymbol}${price} FINAL SALE
    </span>
    `;
  }

  //console.log('firstAvailableVariantIndex')
  //console.log(firstAvailableVariantIndex)
  //console.log(title)
  //console.log(price)
  let html = ``;
  res?.data?.product?.variants.edges.forEach( (edge, i) => {
    //console.log('edge.node.quantityAvailable')
    //console.log(edge.node.quantityAvailable)
    let sizeObjArr = edge.node.selectedOptions.filter(opt => opt.name.toLowerCase() == "size")
    let sizeValue = '';
    if(sizeObjArr.length > 0){
      sizeValue = sizeObjArr[0].value;
    }

    let colorObjArr = edge.node.selectedOptions.filter(opt => opt.name.toLowerCase() == "color")
    let colorValue = '';
    if(colorObjArr.length > 0){
      colorValue = colorObjArr[0].value;
    }

    let checked = (i == firstAvailableVariantIndex && edge.node.quantityAvailable > 0) ? 'checked':'';
    let selected = (i == firstAvailableVariantIndex && edge.node.quantityAvailable > 0) ? 'selected':'';
    let soldoutSRText = '';
    let soldoutClass = '';
    let soldoutDisable = '';
    let available = true;
    let vid = edge.node.id.replace('gid://shopify/ProductVariant/','');
    if(edge.node.quantityAvailable < 1){
      soldoutSRText = `<span class="sr-only">sold out</span>`
      soldoutClass = 'sold-out';
      soldoutDisable = 'disabled';
      available = false;
    }

    buttonHTML += 
    `<label class="option product__swatch ${soldoutClass}" title="${sizeValue}" data-swatch="" data-value="${sizeValue}" data-available="${available}" for="${sizeValue}-${pid}-${item.__queryID}" role="radio" ${soldoutDisable}>
      <input type="radio" class="radio sr-only" id="${sizeValue}-${pid}-${item.__queryID}" name="Size${pid}" value="${sizeValue}" onchange="updateProductSelect(this)" ${checked} ${soldoutDisable}>
      <span>
        ${sizeValue}
      </span>
      ${soldoutSRText}
    </label>`;

    optionsHTML +=
    `<option ${selected} data-option="${colorValue} / ${sizeValue}" data-variant-qty="1" data-variant-id="${vid}" data-preorder="false" data-image="//alcltd.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_300x300.gif" value="${vid}">
      ${colorValue} / ${sizeValue}
    </option>`;

  })



  html += ` 
  <div class="product__item-quickshop content--floating">

    <div>
      <a href="/products/${res?.data?.product?.handle}">
        <h2 class="h1">${title}</h2>
      </a>      
    </div>

    <div class="product__price js-product-price">
      ${priceHTML}
    </div>

    <div class="ajax-atc">
      <div class="">
        <form method="post" action="/cart/add" id="product_form_${pid}" accept-charset="UTF-8" class="product-card__form" enctype="multipart/form-data" data-cart-submit="data-cart-submit">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">

          <div class="product-option product-option--Size" name="size">
            <label class="option-heading" role="presentation">Available Sizes</label>
            <label class="option-heading--mobile">Size</label>
            <div class="flex flex--wrap options-wrap jcc size" role="radiogroup">
              ${buttonHTML}
            </div>
          </div>

          <select name="id" id="product-select-${pid}" class="no-js variantSelect" data-product-select="">
            ${optionsHTML}
          </select>  
  
          <div class="initial-atc-container">
            <div class="initial-atc-msg">PLEASE SELECT A SIZE</div>
            <div class="btn btn--primary initial-atc">
              <span>Add to Bag</span>
            </div>
          </div>
  
          <div class="bis__container">
            <div class="flex add-cart-block">
              <button type="submit" name="add" class="btn btn--primary" data-add-to-cart="">
                <span data-add-to-cart-text="">            
                  Add to Bag
                </span>
              </button>
            </div>
          </div>    

          <input type="hidden" name="product-id" value="${pid}">
        </form>
      </div>
    </div>          
  </div>`;


  document.getElementById(`Card--${item.objectID}-${item.__queryID}`).getElementsByClassName('alg-quickshop')[0].innerHTML = html;
  //addEventListeners(item);

  function addEventListeners(item){
    let optionArr = Array.from(document.getElementById(`Card--${item.objectID}-${item.__queryID}`).getElementsByClassName('option'));
    optionArr.forEach( option => { option.addEventListener('click', e => {
      //console.log('click')
      //console.log(e.target)
      //console.log(e.currentTarget)
      })
    })
  }
}
